import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Association } from '../../../../common/models/association';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { AssociationService } from '../../../../common/services/association.service';
import { Guid } from 'guid-typescript';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-association-view',
  templateUrl: './association-view.component.html',
  styleUrls: ['./association-view.component.scss'],
  imports: [
    CommonModule,
    MatStepperModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    RouterModule
  ]
})
export class AssociationViewComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  isHandset: boolean = false;

  @Input() association!: Association;

  basicInfoFields = [
    { label: 'Naziv udruge', property: 'name', type: 'text' },
    { label: 'OIB', property: 'oib', type: 'text' },
    { label: 'RNO', property: 'rno', type: 'text' },
    { label: 'Email', property: 'email', type: 'text' },
    { label: 'Godina osnutka', property: 'yearOfEstablishment', type: 'number' },
    { label: 'Datum upisa u matični registar', property: 'dateOfRegistration', type: 'date' },
    { label: 'Registarski broj', property: 'registrationNumber', type: 'text' },
    { label: 'Registrirana pri', property: 'registeredAuthority', type: 'text' },
    { label: 'Naziv banke', property: 'bankName', type: 'text' },
    { label: 'Broj žiro-računa (IBAN)', property: 'bankAccountNumber', type: 'text' },
    { label: 'Kontakt broj', property: 'contactNumber', type: 'text' },
    { label: 'Web', property: 'web', type: 'text' }
  ];

  headquartersFields = [
    { label: 'Županija', property: 'county', type: 'text' },
    { label: 'Poštanski broj i sjedište', property: 'postalCodeAndHeadquarters', type: 'text' },
    { label: 'Adresa', property: 'address', type: 'text' }
  ];

  additionalDataFields = [
    { label: 'Ciljevi osnivanja sukladno Statutu', property: 'objectivesAccordingToStatute', type: 'text' },
    { label: 'Svrha i područje djelovanja', property: 'purposeAndFieldOfOperation', type: 'text' },
    { label: 'Djelatnosti prema Statutu', property: 'activitiesAccordingToStatute', type: 'text' }
  ];

  basicInfoFieldValues: Array<{ label: string; property: string; value: any; type: string }> = [];
  headquartersFieldValues: Array<{ label: string; property: string; value: any; type: string }> = [];
  additionalDataFieldValues: Array<{ label: string; property: string; value: any; type: string }> = [];

  constructor(
    private associationService: AssociationService, 
    private route: ActivatedRoute, 
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      this.isHandset = result.matches;
    });

    const associationIdParamName = 'id';
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      if (params.get(associationIdParamName)) {
        const associationIdParam = params.get(associationIdParamName);
        if (!associationIdParam) {
          return;
        }
        const associationId = associationIdParam;
        this.associationService.getAssociation(associationId).pipe(takeUntil(this.destroy$)).subscribe((association) => {
          this.association = association;    
          this.processFields();  
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  processFields(): void {
    this.basicInfoFieldValues = this.basicInfoFields.map(field => ({
      label: field.label,
      property: field.property,
      value: (this.association as any)[field.property],
      type: field.type
    }));

    this.headquartersFieldValues = this.headquartersFields.map(field => ({
      label: field.label,
      property: field.property,
      value: (this.association as any)[field.property],
      type: field.type
    }));

    this.additionalDataFieldValues = this.additionalDataFields.map(field => ({
      label: field.label,
      property: field.property,
      value: (this.association as any)[field.property],
      type: field.type
    }));
  }
}